import React from 'react';
import styled, {css} from 'styled-components';
import {format, parse} from 'date-fns';

import {H2, H4, Body3} from '@bootcamp/web/src/components/Typography/next';

import {Dismiss} from '@styled-icons/fluentui-system-filled/Dismiss';
import {Clock} from '@styled-icons/fluentui-system-filled/Clock';
import {Info} from '@styled-icons/fluentui-system-filled/Info';
import {Checkmark} from '@styled-icons/fluentui-system-filled/Checkmark';

import {TargetArrow} from '@styled-icons/fluentui-system-filled/TargetArrow';
import {ChevronLeft} from '@styled-icons/fluentui-system-filled/ChevronLeft';
import {WeatherSunny} from '@styled-icons/fluentui-system-filled/WeatherSunny';
import {ReactComponent as Rocket} from '@bootcamp/shared/src/assets/svg/rocket.svg';
import {RoundButton} from '@bootcamp/web/src/components/UI';
import {Wand} from '@styled-icons/fluentui-system-filled/Wand';
import {Warning} from '@styled-icons/fluentui-system-filled/Warning';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  max-width: 857px;
  min-height: 736px;
  width: calc(100% - 24px);
  position: relative;

  ${({theme}) => theme.mediaQueries.tablet} {
    position: absolute;
    padding-top: 48px;
    background: transparent;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    max-height: none;
    min-height: auto;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  `;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border-bottom: 1px solid ${({theme}) => theme.colors.neutralsPalette.light};

  ${({theme}) => theme.mediaQueries.tablet} {
    background: white;
    border-radius: 8px 8px 0px 0px;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding: 0;
  position: relative;

  ${({theme}) => theme.mediaQueries.tablet} {
    background: white;
    flex-direction: column;
    overflow: auto;
  }
`;
export const HeaderText = styled(H4)`

`;
export const Header2Text = styled(H2)`

`;
export const BackIcon = styled(ChevronLeft)`
  position: absolute;
  left: 24px;
  color: #2F3037;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
export const CloseIcon = styled(Dismiss)`
  position: absolute;
  right: 24px;
  color: black;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
export const Chiclet = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  height: 24px;
  border-radius: 8px;
  background: ${({theme, color}) => theme.colors.assignmentColorPalette[color || 'grey'].light};
  color: ${({theme, color}) => theme.colors.assignmentColorPalette[color || 'grey'].dark};
  border: ${({theme, color}) => `1px solid ${theme.colors.assignmentColorPalette[color || 'grey'].dark}1a`};
  font-family: proxima-nova;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
`;
export const ButtonArea = styled.div`
  margin-top: auto;
`;
export const Panel = styled.div`
  padding: 0 24px;
  flex: 1;
`;

export const ConfirmationPanel = styled(Panel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 48px;
`;

export const Left = styled(Panel)`
  ${({theme}) => theme.mediaQueries.tablet} {
    padding: 0 24px;
  }
`;
export const Right = styled(Panel)`
  display: flex;
  flex-direction: column;
  background: ${({theme}) => theme.colors.backgroundPalette.secondary};
  padding: 24px;
  border-left: 1px solid rgb(237, 237, 240);
  border-bottom-right-radius: 8px;
`;
export const RightSection = styled.div`
  display: flex;
  background: white;
  border: 1px solid ${({theme}) => theme.colors.borderPalette.primary};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
`;
export const CreateAreaText = styled(Body3)`
  color: ${({theme}) => theme.colors.typographyPalette.secondary};
  text-align: center;
  margin-top: 12px;
`;
export const CreateButton = styled(RoundButton)`
  width: 100%;
`;
export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: space-between;
  margin-right: 4px;
`;
export const Line = styled.div`
  flex: 1;
  width: 1px;
  border: 1px dashed ${({theme}) => theme.colors.brandPalette.royal.default};
  margin: 8px auto;
`;
export const TimelineArea = styled.div`
  width: 100%;
`;
export const TimelineAreaText = styled.div`
  margin-left: 8px;
`;
export const TimelineAreaTextHeading = styled(Body3)`
  font-weight: 700;
`;
export const TimelineAreaTextSubheading = styled(Body3)`
  color: ${({theme}) => theme.colors.typographyPalette.secondary};
  line-height: 100%;
  margin-top: 2px;
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.colors.brandPalette.royal.extraLight};
  border-radius: 8px;
  width: 40px;
  height: 40px;
`;
export const StyledRocket = styled(Rocket)`
  width: 20px;
  height: 20px;
  color: ${({theme}) => theme.colors.brandPalette.royal.default};
  path {
    fill: ${({theme}) => theme.colors.brandPalette.royal.default};
  }
`;
export const StyledWand = styled(Wand)`
  width: 20px;
  height: 20px;
  color: ${({theme}) => theme.colors.brandPalette.royal.default};
  path {
    fill: ${({theme}) => theme.colors.brandPalette.royal.default};
  }
`;
export const StyledSun = styled(WeatherSunny)`
  width: 20px;
  height: 20px;
  color: ${({theme}) => theme.colors.brandPalette.royal.default};

`;
export const StyledTarget = styled(TargetArrow)`
  width: 20px;
  height: 20px;
  color: ${({theme}) => theme.colors.brandPalette.royal.default};
`;

export const EstimateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 32px 0px;
`;

export const Estimate = styled.div`
  padding: 12px;
  background: ${({theme, color}) => color === 'orange'
    ? theme.colors.brandPalette.orange.light
    : color === 'grey'
    ? theme.colors.backgroundPalette.secondary
    : theme.colors.interfacePalette[color].light
  }80;
  border-radius: 8px;
  color: ${({theme, color}) => color === 'orange'
    ? theme.colors.brandPalette.orange.dark
    : color === 'grey'
    ? theme.colors.typographyPalette.secondary
    : theme.colors.interfacePalette[color].dark
  };

  border: 1px solid ${({theme, color}) => color === 'orange'
    ? theme.colors.brandPalette.orange.dark
    : color === 'grey'
    ? theme.colors.borderPalette.secondary
    : theme.colors.interfacePalette[color].dark
  }80;
  display: flex;
  flex-direction: row;
  align-items: ${({hideSubheading}) => hideSubheading ? 'center' : 'flex-start'};
  width: 100%;
  ${({theme, color}) => css`
    ${IconContent} {
      ${color === 'orange'
        ? `background: ${theme.colors.brandPalette.orange.light};`
        : color === 'grey'
        ? `background: ${theme.colors.typographyPalette.secondary};`
        : `background: ${theme.colors.interfacePalette[color].light};`}
    }
  `}
`;
export const ClockIcon = styled(Clock)`
  width: 20px;
  height: 20px;
`;
export const WarningIcon = styled(Warning)`
  width: 20px;
  height: 20px;
`;

export const IconContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 12px;
  min-width: 40px;
  border-radius: 8px;
`;

export const InfoIcon = styled(Info)`
  width: 20px;
  height: 20px;
`;
export const EstimateHeading = styled(TimelineAreaTextHeading)`
  display: flex;
  align-items: center;
  font-weight: 700;
`;
export const EstimateSubheading = styled(Body3)`
  color: ${({theme, color}) => color === 'orange'
    ? theme.colors.brandPalette.orange.dark
    : color === 'grey'
    ? theme.colors.typographyPalette.secondary
    : theme.colors.interfacePalette[color].dark
  };
  line-height: 130%;
`;

export const EstimateContent = styled.div`
  width: auto;
`;
export const Section = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.neutralsPalette.light};

  &:last-child {
    border-bottom: none;
  }
`;
export const Heading = styled(H4)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;
export const Subheading = styled(Body3)`
  color: ${({theme}) => theme.colors.typographyPalette.secondary};
  margin-bottom: 16px;
`;
export const RightHeading = styled(H4)`
  margin-bottom: 16px;
`;

export const EstimateSection = ({hoursPerDay, hideSubheading, rebalance}) => {
  if (!hoursPerDay) {
    return (
      <Estimate color="grey" hideSubheading={hideSubheading}>
        {!hideSubheading && <EstimateSubheading color="grey">Choose an exam date to see your Study Schedule timeline.</EstimateSubheading>}
      </Estimate>
    );
  };

  if (hoursPerDay <= 1) {
    return (
      <Estimate color="red" hideSubheading={hideSubheading}>
        <IconContent><WarningIcon /></IconContent>
        <EstimateContent>
          <EstimateHeading>
            Less than {Math.ceil(hoursPerDay)} hour daily
          </EstimateHeading>
          {!hideSubheading && <EstimateSubheading color="red">We recommend moving your exam date to an earlier time.</EstimateSubheading>}
        </EstimateContent>
      </Estimate>
    )
  }
  if (hoursPerDay >= 10) {
    return (
      <Estimate color="red" hideSubheading={hideSubheading}>
        <IconContent><WarningIcon /></IconContent>
        <EstimateContent>
          <EstimateHeading>
            More than {Math.ceil(hoursPerDay)} hours daily
          </EstimateHeading>
          {!hideSubheading && <EstimateSubheading color="red">We recommend pushing back your exam date.</EstimateSubheading>}
        </EstimateContent>
      </Estimate>
    )
  }
  return (
    <Estimate color="green" hideSubheading={hideSubheading}>
      <IconContent><ClockIcon /></IconContent>
      <EstimateContent>
        <EstimateHeading>
          About {Math.ceil(hoursPerDay)} hours daily
        </EstimateHeading>
        {!hideSubheading && <EstimateSubheading color="green">{rebalance ? `After rebalancing, you'll be studying about ${Math.ceil(hoursPerDay)} hours per day. You've got this!` : `That's a great start!`}</EstimateSubheading>}
      </EstimateContent>
    </Estimate>
  )
};

export const TimelineComponent = ({
  startDate,
  rebalance,
  hoursPerDay,
  expirationBeforeExamDate,
  examDate,
  children,
  hideSubheading,
  startingExamDate,
}) => {
  return (
    <RightSection>
      <Timeline>
        <IconWrapper>
          {rebalance ? <StyledWand /> : <StyledRocket/>}
        </IconWrapper>
        <Line/>
        <IconWrapper>
          <StyledTarget/>
        </IconWrapper>
      </Timeline>
      <TimelineArea>
        <TimelineAreaText>
          <TimelineAreaTextHeading>{format(parse(startDate, 'yyyy-MM-dd', new Date()), 'MMM do, yyyy')}</TimelineAreaTextHeading>
          <TimelineAreaTextSubheading>{rebalance ? 'Rebalance' : ''} Start Date</TimelineAreaTextSubheading>
        </TimelineAreaText>
        <EstimateList>
          <EstimateSection hoursPerDay={hoursPerDay} hideSubheading={hideSubheading} rebalance={rebalance} />
          {expirationBeforeExamDate && (
            <Estimate color="yellow">
              <IconContent><InfoIcon /></IconContent>
              <EstimateContent>
                <EstimateHeading>
                  Membership Ends before Exam Date
                </EstimateHeading>
                <EstimateSubheading color="yellow">We'll continue scheduling your assignments up to your Exam Date. You can extend your membership any time!</EstimateSubheading>
              </EstimateContent>
            </Estimate>
          )}
          {children}
        </EstimateList>
        <TimelineAreaText>
          <TimelineAreaTextHeading>
            {examDate
              ? format(parse(examDate, 'yyyy-MM-dd', new Date()), 'MMM do, yyyy')
              : 'Select a date'
            }
          </TimelineAreaTextHeading>
          <TimelineAreaTextSubheading>{rebalance && startingExamDate != examDate ? 'New' : ''} Exam Date</TimelineAreaTextSubheading>
        </TimelineAreaText>
      </TimelineArea>
    </RightSection>
  );
};
